import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner">
      {/* Spinner animation được định nghĩa trong global.css */}
    </div>
  );
};

export default LoadingSpinner; 